import { Format } from '../../../../lib/dateFns';
import utilsStyles from '../../../../styles/modules/utils.module.scss';
import { formatDateCommon } from '../../../../utils/formatters';
import type { ArticleHeaderProps } from '../../types';
import styles from './ArticleHeader.module.scss';

/*:
 * 記事ヘッダー
 * デザイン共通
 */
function ArticleHeader({ publishedAt, title }: ArticleHeaderProps) {
  return (
    <header className={styles.componentStyle}>
      <span className={styles.articleDate}>{formatDateCommon(publishedAt, Format.dateJa)}</span>
      <h1 className={`${styles.articleTitle} ${utilsStyles.textBold}`}>{title}</h1>
    </header>
  );
}

export default ArticleHeader;
